import styled from '@emotion/styled'
import { motion } from 'framer-motion'

const Section = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;

  ul {
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }

  li {
    list-style: none;
    background-color: #eee;
  }
`

interface Props {
  count?: number
  duration?: number
  isLoadMoreComponent?: boolean
  height?: number
  gap?: number
}

export const ListLoader = ({ count = 3, duration = 2, height = 30, gap = 15 }: Props) => {
  const placeholderArray = Array(count).fill(null)

  const container = {
    hidden: {
      opacity: 0,
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.5,
        ease: 'easeInOut',
      },
    },
  }

  const item = {
    hidden: {
      opacity: 0,
    },
    show: i => ({
      opacity: [0, 0.3, 0.8, 1, 0.8, 0.3, 0],
      transition: {
        ease: 'easeInOut',
        duration,
        delay: i * 0.2,
        repeat: Infinity,
      },
    }),
  }

  return (
    <Section>
      <motion.ul variants={container} initial="hidden" animate="show" style={{ gap }}>
        {placeholderArray.map((_, i) => (
          <motion.li key={i} custom={i} variants={item} style={{ height }} />
        ))}
      </motion.ul>
    </Section>
  )
}
